module.exports = __webpack_public_path__ + "img/red-card-icon.d4ac8a20.png";